export default {
	setting: {
		signInRelativeUrl: 'SignIn'
	}
};
